$('document').ready(function () {
    // Enable tooltips everywhere
    $('table.dataTable[data-table="simple"]').DataTable({
        dom: 'Brt<"dataTables_footer"ip>',
        language: {
            url: '/assets/plugins/DataTables/i18n/Turkish.json'
        },
        scrollX: true,
    });

    // Enable tooltips everywhere
    $('[data-toggle="tooltip"]').tooltip();

    // Enable popovers everywhere
    $('[data-toggle="popover"]').popover();

    autosize($('textarea.autoResize'));

    // Enable Custom Scrollbars only for desktop
    const mobileDetect = new MobileDetect(window.navigator.userAgent);
    if (!mobileDetect.mobile()) {
        $('.custom-scrollbar').each(function () {
            new PerfectScrollbar(this);
        })
    } else {
        $('body').addClass('is-mobile');
    }

    // Data tables fix header resize
    $(window).on('resize', function () {
        $.fn.dataTable.tables({
            visible: true,
            api: true
        }).columns.adjust();
    });

    // PNotify default styling.
    PNotify.defaults.styling = 'material';
    PNotify.defaults.icons = 'material';

    const select2 = $('.select2');
    select2.each(function () {
        $(this).select2({
            matcher: function (params, data) {
                params.term = params.term || '';
                if (data.text.trim().replace('i', 'İ').toUpperCase().indexOf(params.term.trim().replace('i', 'İ').toUpperCase()) === 0) {
                    return data;
                }
                return false;
            }
        });

        if (!$(this).attr('multiple')) {
            $(this).on('select2:open', function () {
                $('.select2-search__field')[0].focus();
            });
        }
    });


    $('.dateRangePicker').each(function () {
        $(this).daterangepicker({
            ranges: {
                'Bu gün': [moment(), moment()],
                'Dün': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Evvelsi Gün': [moment().subtract(2, 'days'), moment().subtract(2, 'days')],
                'Bu Ay': [moment().startOf('month'), moment()],
                'Bu Yıl': [moment().startOf('year'), moment()],
                'Son 3 Gün': [moment().subtract(3, 'days'), moment()],
                'Son 7 Gün': [moment().subtract(6, 'days'), moment()],
                'Son 30 Gün': [moment().subtract(30, 'days'), moment()],
                'Geçen Gün': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Geçen Hafta': [moment().subtract(1, 'week').startOf('week').add(1, 'days'), moment().subtract(1, 'week').endOf('week').add(1, 'days')],
                'Geçen Ay': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'Geçen Üç Ay': [moment().subtract(3, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'Geçen 6 Ay': [moment().subtract(6, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'Geçen Yıl': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')],
            },
            locale: {
                format: 'DD.MM.YYYY',
                separator: ' - ',
                applyLabel: 'Onayla',
                cancelLabel: 'İptal Et',
                fromLabel: 'From',
                toLabel: 'To',
                customRangeLabel: 'Seç',
                weekLabel: 'H',
                daysOfWeek: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'],
                monthNames: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
                firstDay: 1
            },
            alwaysShowCalendars: true,
            buttonClasses: 'btn',
            applyButtonClasses: 'btn-secondary',
            cancelClass: 'btn-danger',
            opens: 'left',
            autoApply: true,
            startDate: $(this).attr('data-start'),
            endDate: $(this).attr('data-end'),
        });

        $(this).on('apply.daterangepicker', function (e, picker) {
            const form = $(this).parents('form')
            $('input[name="filter[date][start]"]', form).val(picker.startDate.format('YYYY-MM-DD'));
            $('input[name="filter[date][end]"]', form).val(picker.endDate.format('YYYY-MM-DD'));
        });
    });

    $('.dateTimePicker').daterangepicker({
        ranges: {
            'Bugün': [moment(), moment()],
            'Dün': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Evvelsi Gün': [moment().subtract(2, 'days'), moment().subtract(2, 'days')],
        },
        locale: {
            format: 'DD.MM.YYYY HH:mm:ss',
            separator: ' - ',
            applyLabel: 'Onayla',
            cancelLabel: 'İptal Et',
            fromLabel: 'From',
            toLabel: 'To',
            customRangeLabel: 'Seç',
            weekLabel: 'W',
            daysOfWeek: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'],
            monthNames: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
            firstDay: 1
        },
        startDate: moment(),
        endDate: moment(),
        opens: 'center',
        drops: 'auto',
        buttonClasses: 'btn',
        applyButtonClasses: 'btn-secondary',
        cancelClass: 'btn-light',
        singleDatePicker: true,
        showDropdowns: true,
        timePicker: true,
        timePicker24Hour: true,
        timePickerSeconds: true,
        timePickerIncrement: 1,
        maxSpan: {
            days: 7
        },
    }).on('apply.daterangepicker', function (e, picker) {
        $(this).val(picker.startDate.format('DD.MM.YYYY HH:mm:ss'));
    });

    $.expr[":"].contains = $.expr.createPseudo(function (arg) {
        return function (elem) {
            return $(elem).text().replace('i', 'İ').toUpperCase().indexOf(arg.replace('i', 'İ').toUpperCase()) >= 0;
        };
    });
});
